/* src/app/shared/components/header/header.component.scss */
.right-header-items {
  flex: 40%;
}
.right-header-items .navbar-nav {
  column-gap: 1.5rem;
}
.left-header-items {
  flex: 30%;
  float: left;
  margin-top: 8px;
}
.left-header-items .left-header-wrapper {
  align-items: center;
}
.chevron-size {
  font-size: 2em;
}
.large-font {
  font-size: 2em;
}
.right-header-items ul li {
  float: right;
}
.left-header-items ul {
  width: 100%;
}
#assessment-header nav {
  height: 40px;
  border-bottom: 1px solid #bdbdbd;
  color: #6c757d;
}
#assessment-header .right-header-items > ul {
  float: right;
  color: #222222;
}
#assessment-header .right-header-items > ul > li .previewTitle {
  background-color: grey;
  text-align: center;
  border-radius: 4px;
}
#assessment-header .right-header-items > ul > li .previewTitle > .preview-text-color {
  color: white;
}
.header-name {
  font-size: 25px;
}
.rename-header-align {
  color: red;
  border-radius: 5px;
  position: relative;
  left: 50px;
}
#questionTypeContainer {
  position: relative;
  margin-top: -7px;
  margin-left: 20px;
}
.modal-dialog {
  position: relative;
  top: 50%;
  width: 300px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-more-info {
  position: fixed;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: calc(50% - 150px);
}
.modal-dialog-more-info-new {
  position: relative;
  top: 50%;
  width: 700px;
  max-width: 95dvw;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-more-info-new .modal-content {
  height: auto;
}
.modal-dialog-more-info-new .modal-content .iframe-body-single {
  height: 380px;
  width: 552px;
}
.modal-dialog-more-info-new .modal-content .iframe-body-multiple {
  height: 284px;
  width: 552px;
}
.modal-dialog-copy {
  position: relative;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-copy .modal-content {
  height: 250px;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-container-new {
  position: relative;
  width: 100%;
  background: black;
  height: 100%;
  opacity: 0.9;
}
.modal-header-new {
  background-color: #174d5c;
  color: #fff;
  height: 45px;
  padding: 12px 18px 12px 30px;
}
.modal-header-new .modal-title {
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}
.modal-body-new {
  position: relative;
  flex: 1 1 auto;
  padding: 30px;
  max-height: calc(95dvh - 45px);
}
.modal-body-copy {
  position: relative;
  flex: 1 1 auto;
  padding: 30px 0 0 30px;
}
.editor-msg {
  padding: 75px 16px 99px 67px;
  font-size: 25px;
  color: #666666;
}
.modal-header-message {
  padding: 0px 0px 27px 0px;
}
.header-span {
  font-weight: bold;
  color: black;
}
.rename-up {
  padding-bottom: 2px;
  margin-left: 5px;
  margin-right: 10px;
}
.rename-down {
  padding-bottom: 2px;
  margin-left: 5px;
  margin-right: 10px;
}
.back-btn-up {
  width: 42px;
}
.top-2 {
  position: relative;
  top: -1px;
}
.title-head {
  font-size: 18px;
  font-weight: bold;
  color: #265867;
}
.back-btn-down {
  width: 42px;
  position: relative;
}
.assessment-title {
  padding-top: 6px;
  width: 220px;
}
.right-hand-header-text-margin {
  margin-right: 27px;
}
.head-alert {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}
@media (max-width: 767px) {
  .head-alert {
    left: auto;
    right: 16px;
    padding: 0 16px;
    transform: translateY(-74%);
  }
  .left-header-items {
    flex: 40%;
  }
  .right-header-items {
    flex: 50%;
  }
  .left-header-wrapper {
    display: flex;
    flex-direction: row;
    margin-left: 0;
  }
  #assessment-header nav {
    height: auto;
  }
  .navbar {
    padding: 0 30px;
  }
  #renameHeader {
    line-height: 18px;
  }
}
@media (max-width: 575px) {
  .navbar {
    padding: 0 13px;
  }
  .left-header-items {
    max-width: 100%;
    margin-top: 0px;
  }
  .left-header-items .left-header-wrapper {
    margin-top: 0;
    margin-bottom: 0;
  }
  .head-alert {
    left: 15%;
    right: 0;
    padding: 0 9px;
    margin: auto;
    transform: translateY(-70%);
  }
  .right-header-items .navbar-nav {
    margin-top: 0;
  }
}
.back-btn {
  margin-bottom: 6px;
}
@media (max-width: 575px) {
  .modal-overlay .modal-container-new {
    padding: 24px 0px;
    display: flex;
  }
  .modal-overlay .modal-container-new .modal-dialog-more-info-new {
    width: 90%;
  }
  .modal-overlay .modal-container-new .modal-dialog-more-info-new .modal-content {
    height: 100%;
  }
  .modal-overlay .modal-container-new .modal-dialog-more-info-new .modal-content .modal-header-new {
    padding: 12px 18px 12px 18px;
    display: flex;
    align-items: center;
  }
  .modal-overlay .modal-container-new .modal-dialog-more-info-new .modal-content .modal-body-new {
    padding: 16px 12px;
    overflow-y: auto;
  }
  .modal-overlay .modal-container-new .modal-dialog-more-info-new .modal-content .modal-body-new .editor-msg {
    padding: 0;
  }
}
@media (max-height: 390px) {
  .modal-body-new .editor-msg {
    padding: 0;
  }
}
/*# sourceMappingURL=header.component.css.map */
